/**
 * Tabs
 *
 * @example
 * tabs();
 * or
 * tabs({
 *     parent: '.tab',
 *     menu: '.tab__menu',
 *     item: '.tab__item',
 *     class: 'is-current',
 *     menu_item: '.tab__menu-item',
 * });
 *.footer__logo.is-mobile
 * @param {Object} [options] - Tab options
 *
 * @returns {void}
 */
const tabs = (options) => {
    const defaults = {
        parent: '.tab',
        menu: '.tab__menu',
        item: '.tab__item',
        class: 'is-current',
        menu_item: '.tab__menu-item',
        work_with: 'classes'
    };

    const settings = $.extend({}, defaults, options);

    let selector = settings.menu_item + ':not(.' + settings.class + ')';

    if($(window).width() <= 576) {
        settings.parent += '.is-mobile'
        selector = settings.menu_item;
    }

    console.log('settings.work_with', settings.work_with)

    $(settings.menu).on('click', selector, function () {
        let current = $(this);

        if(settings.work_with === 'classes') {
            current
                .addClass(settings.class)
                .siblings()
                .removeClass(settings.class)
                .closest(settings.parent)
                .find(settings.item)
                .removeClass(settings.class)
                .eq(current.index())
                .addClass(settings.class);
        }
        else if(settings.work_with === 'data') {

            if(current.hasClass(settings.class)) {
                console.log('has class');
                current.removeClass(settings.class);
                $(settings.item + '[data-menu="' + current.data('tab') + '"]').removeClass(settings.class)
            }
            else {
                console.log('current', current)
                $(settings.menu_item).removeClass(settings.class);
                $(settings.item).removeClass(settings.class);
                current.addClass(settings.class);

                console.log('current.hasClass', current.hasClass(settings.class))

                $(settings.item + '[data-menu="' + current.data('tab') + '"]').addClass(settings.class)
            }

        }

    });

    $(document).ready(function () {
        $(settings.menu).parents(settings.parent).find(selector).eq(0).click();
    });

};

export default tabs;
